module.exports = __webpack_public_path__ + "static/media/vikings.96a5a2e9.jpg";